import React from 'react';
import { Home } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-8 py-6 rounded-t-3xl">
      <div className="flex items-center gap-3">
        <Home size={32} className="text-white" />
        <div>
          <h1 className="font-bold text-white">Immobilien-Dashboard Regensburg</h1>
          <p className="text-blue-100">Investment Analyse & Portfolio Management</p>
        </div>
      </div>
    </div>
  );
};

export default Header;